<template>
  <!--编辑用户-->
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <ak-inputs v-model="workShop" :options="workShops" v-if="isWorkShop" ref="input1" />
    <ak-inputs v-model="allBatching" :options="batching" v-if="!isWorkShop" ref="input2" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" :loading="loading" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
// import { isNull } from '../../assets/js/validators'

export default {
  data () {
    return {
      loading: false,
      oriCorrelateUser: [],
      data: {
        name: '', // 姓名
        username: '', // 电话
        // adminRole: '', // 权限
        company: '', // 公司
        distribution: '', // 权限分配
        allClient: '', // 是否可见所有用户
        allShopManagements: '', // 是否可见所有车间
        // operate: '', // 车间权限
        correlatedUser: [] // 关联用户
      },
      workShop: {
        shopManagements: [], // 管理车间
      },
      allBatching: {
        allBatching: '',
      },
      // clientView: {
      //   client: [], // 可见客户
      // },
      options: [
        {
          name: 'name',
          note: '姓名',
          type: 'String',
          validators: [
            (val) => val ? null : '姓名不可为空'
          ]
        },
        {
          name: 'username',
          note: '手机账户',
          type: 'String',
          tooltip: '初始密码为：123456',
          validators: [
            (val) => val ? null : '手机账户不可为空',
            (val) => {
              if (!(/^1[3456789]\d{9}$/.test(val))) {
                return '请输入正确的手机号码'
              }
            }
          ]
        },
        // {
        //   name: 'adminRole',
        //   note: '人员权限',
        //   type: 'Select',
        //   validators: [
        //     (val) => val ? null : '权限不可为空'
        //   ],
        //   items: {
        //     workshop: '车间经理',
        //     sale: '销售经理',
        //     finance: '财务经理',
        //     admin: '超级管理员',
        //     staff: '内勤人员',
        //     undetermined: '待定人员'
        //   }
        // },
        {
          name: 'company',
          note: '所属公司',
          type: 'Pointer',
          targetClass: 'company',
          validators: [
            (val) => val ? null : '所属公司不可为空'
          ]
        },
        {
          name: 'allClient',
          note: '客户权限',
          type: 'Select',
          tooltip: '选择“全部”，可见所有客户、所有用户创建的订单、所有用户工资；选择“辖区”，仅可见相关客户、自己创建的订单、自己以及下属工资',
          items: {
            Yes: '全部',
            No: '辖区'
          },
          validators: [
            (val) => val ? null : '权限不可为空'
          ]
        },
        // {
        //   name: 'distribution',
        //   note: '权限分配',
        //   type: 'Select',
        //   items: {
        //     Yes: '有',
        //     No: '无'
        //   },
        //   validators: [
        //     (val) => val ? null : '权限不可为空'
        //   ]
        // },
        {
          name: 'correlatedUser',
          note: '我的上级经理',
          type: 'Array',
          tooltip: '我的上级经理可审核此账号创建订单',
          items: { type: 'Pointer', targetClass: '_User' },
          listWhere: (where) => {
            where.username = { $exists: true }
          }
        },
        {
          name: 'allShopManagements',
          note: '车间权限',
          type: 'Select',
          tooltip: '选择“全部”,可管理所有车间；选择“辖区”,仅可管理分配车间',
          items: {
            Yes: '全部',
            No: '辖区'
          },
          validators: [
            (val) => val ? null : '不可为空'
          ]
        },
      ],
      workShops: [
        {
          name: 'shopManagements',
          note: '管理车间',
          type: 'Array',
          items: { type: 'Pointer', targetClass: 'shopManagement' },
          listWhere: (where) => {
            where.type = 'workShop'
          },
        },
      ],
      batching: [
        {
          name: 'allBatching',
          note: '配样权限',
          type: 'Select',
          tooltip: '选择“全部”,可见所有配样;选择“辖区”,仅可见自己创建的配样',
          items: {
            Yes: '全部',
            No: '辖区'
          },
          validators: [
            (val) => val ? null : '不可为空'
          ]
        },
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    // 仅用户权限为车间经理时展示
    isWorkShop () {
      return this.data.allShopManagements === 'No'
    }
  },
  created () {
  },
  async mounted () {
    if (this.record) {
      this.data = {
        name: this.record.name,
        username: this.record.username,
        distribution: this.record.distribution,
        allClient: this.record.allClient,
        // adminRole: this.record.adminRole,
        company: this.record.company.objectId,
        allShopManagements: this.record.allShopManagements
      }
      if (this.record.shopManagements) { this.workShop.shopManagements = this.record.shopManagements }
      if (this.record.correlatedUser) { this.data.correlatedUser = this.record.correlatedUser }
      if (this.record.allBatching) { this.allBatching.allBatching = this.record.allBatching }
      // if (this.record.client) { this.authority.client = this.record.client }
      // if (this.record.allClient && this.record.allClient === 'No') { this.isabled = true }
      this.oriCorrelateUser = this.record.correlatedUser
      // console.log('原数组', this.oriCorrelateUser)
    } else {
      this.data.password = '123456'
    }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    // 为被关联用户添加标记
    async addLabel (val) {
      if (this.data.correlatedUser.length) {
        try {
          let x = this.data.correlatedUser
          for (let i in x) {
            let { data: res } = await this.$modelAjax.get('_User', {
              params: {
                where: {
                  objectId: x[i]
                }
              }
            })

            let r = res.results[0]
            // console.log(r)
            if (r.correlatedBy) {
              if (r.correlatedBy.indexOf(val) === -1) {
                r.correlatedBy.push(val)
              } else {

              }
            } else {
              r['correlatedBy'] = [val]
            }
            await this.$modelAjax.put('_User', r.objectId, r)
          }
        } catch (e) {
          this.loading = !this.loading
          console.log('111')
          throw this.$notification['error']({
            message: '保存失败',
            description: '保存失败，请重新尝试'
          })
        }
      }
    },
    async disLabel (val) {
      try {
        // 取消关联用用户删除标记
        for (let d in this.oriCorrelateUser) {
          if (this.data.correlatedUser.indexOf(this.oriCorrelateUser[d]) === -1) {
            let { data: res1 } = await this.$modelAjax.get('_User', {
              params: {
                where: {
                  objectId: this.oriCorrelateUser[d]
                }
              }
            })
            let r1 = res1.results[0]

            r1.correlatedBy.splice(r1.correlatedBy.indexOf(val), 1)
            await this.$modelAjax.put('_User', r1.objectId, r1)
          }
        }
      } catch (e) {
        this.loading = !this.loading
        throw this.$notification['error']({
          message: '保存失败',
          description: '保存失败，请重新尝试'
        })
      }
    },
    async submit () {
      // 验证必填项
      let erros = await this.$refs.input.validate()
      let error = {}
      let error1 = {}
      if (this.isWorkShop) { error = await this.$refs.input1.validate() } else {
        this.workShop = { shopManagements: [] }
      }
      if (!this.isWorkShop) { error1 = await this.$refs.input2.validate() } else {
        this.allBatching = { allBatching: '' }
      }
      // if (this.isabled) {
      //   error1 = await this.$refs.input2.validate()
      // } else {
      //   this.clientView = { client: [] }
      // }
      if (Object.keys(erros).length || Object.keys(error).length || Object.keys(error1).length) return
      this.data = { ...this.data, ...this.workShop, ...this.allBatching }

      // 新建
      this.loading = !this.loading
      if (!this.record) {
        let { data: result } = await this.$modelAjax.post('_User', this.data).catch(e => {
          this.loading = !this.loading
          throw this.$notification['error']({
            message: '保存失败',
            description: '保存失败，请重新尝试'
          })
        })
        this.addLabel(result.objectId)
      }

      // 编辑
      if (this.record) {
        await this.$modelAjax.put('_User', this.record.objectId, this.data)
        this.addLabel(this.record.objectId)
        this.disLabel(this.record.objectId)
        // if (this.data.correlatedUser.length) {

        // }
      }

      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    },
  },
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String, // 假如当前model显示为category格式，则会将当前的值传入
    title: String
  }
}
</script>

<style scoped lang="scss">
</style>
